export default function repeat<T>(times: number, cb: (index: number) => T) {
  return Array.from(new Array(times).keys()).map(cb);
}
